import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { getAllSubscribers } from "store/actions";

import Table from "./Table";

const Subscribers = () => {
  const dispatch = useDispatch();
  const { subscribers, loading, error } = useSelector(
    (state) => state.subscribers
  );
  const { formatMessage, locale } = useIntl();
  console.log(subscribers);
  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  useEffect(() => {
    dispatch(getAllSubscribers());
  }, [dispatch]);

  return (
    <div className="property-wrap">
      <Table data={subscribers} loading={loading} />
    </div>
  );
};

export default Subscribers;
